export const PAGE_HEIGHT_PDF = 1350;
export const PAGE_WIDTH_PDF = 900;
export const HEIGHT_TOLERANCE_PX = 0.5;

/** Dev switch, in localStorage so it survives a reload: the export stops right before the browser's print dialog. */
export const NO_PRINT_KEY = "NO_PRINT";
